<template>
  <div class="search-page px-4 pt-7.5 xl:container xl:mx-auto relative">
    <form
      ref="searchForm"
      name="searchForm"
      method="get"
      class="flex flex-col gap-8 md:gap-14 form-search-page"
      @submit.prevent="submitSearch"
    >
      <div class="bg-custom-search px-4 py-8 md:p-13 rounded-lg">
        <div class="search-custom-size">
          <h1 class="search-title-ai" v-html="allText.title"></h1>
          <div class="search-box-ai">
            <div class="relative w-full search-box-ai-content">
              <input
                type="text"
                :placeholder="
                  allText.placeholder | replaceLabel(localData.design.labels)
                "
                name="filters[keyword]"
                v-model="localData.applied_filters.keyword"
                :disabled="isSearchingIA"
                autofocus
              />
              <button
                class="input-button"
                type="submit"
                :disabled="
                  isSearchingIA ||
                  isSearching ||
                  localData.applied_filters.keyword.length < 3
                "
              >
                <span>
                  {{
                    isSearchingIA
                      ? allText.searchingWithAi
                      : allText.searchWithAi
                  }}
                </span>
                <i
                  class="w-5 h-5 fill-none flex-none transition-transform"
                  :class="{ 'animate-magic-wand': isSearchingIA }"
                  v-icon:search-bar-ia
                ></i>
              </button>
            </div>

            <button
              class="mobile-button"
              type="submit"
              :disabled="
                isSearchingIA ||
                isSearching ||
                localData.applied_filters.keyword.length < 3
              "
            >
              <span>
                {{
                  isSearchingIA ? allText.searchingWithAi : allText.searchWithAi
                }}
              </span>
              <i
                class="w-5 h-5 fill-none flex-none transition-transform"
                :class="{ 'animate-magic-wand': isSearchingIA }"
                v-icon:search-bar-ia
              ></i>
            </button>
          </div>
        </div>
        <div
          class="search-content-ai"
          v-if="(hasDataAi || isSearchingIA) && !hasErrorAI"
        >
          <div
            class="search-content-ai-body bg-white bg-opacity-20 p-3 md:p-10 rounded-lg"
          >
            <template v-if="isSearchingIA">
              <div
                class="search-content-ai-body-left animate-pulse mb-6 md:mb-0"
              >
                <span class="text-xs text-geb-aquamarine uppercase">{{
                  allText.searching
                }}</span>
                <div class="section">
                  <div class="h-7 rounded-lg bg-white bg-opacity-40"></div>
                  <p class="mt-2 rounded-lg bg-white bg-opacity-40 h-17"></p>
                </div>
              </div>

              <div class="search-content-ai-body-right animate-pulse">
                <span class="text-xs text-geb-aquamarine">{{
                  allText.sources
                }}</span>
                <div class="section">
                  <ul class="space-y-2">
                    <li class="flex h-6 bg-white bg-opacity-40 rounded-lg"></li>
                    <li class="flex h-6 bg-white bg-opacity-40 rounded-lg"></li>
                    <li class="flex h-6 bg-white bg-opacity-40 rounded-lg"></li>
                  </ul>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="search-content-ai-body-left mb-6 md:mb-0">
                <span class="text-xs text-geb-aquamarine uppercase">{{
                  allText.response
                }}</span>
                <div class="section">
                  <h3
                    class="text-xl font-semibold flex items-center gap-2"
                    v-if="hasDataAi && dataAI.ai.title"
                    data-testid="result-search-title"
                  >
                    {{ dataAI.ai.title }}
                  </h3>
                  <p
                    data-testid="result-search-content"
                    ref="typedText"
                    class="flex flex-col gap-3 my-2 text-sm max-h-48 overflow-auto custom-scroll"
                  ></p>
                  <!-- <button
                    type="button"
                    class="text-geb-aquamarine text-xs mt-2 inline-block"
                    @click="toggleTypedTextShow"

                  >
                    {{
                      showTypedTextShow
                        ? allText.viewLessToSee
                        : allText.viewMore
                    }}
                  </button> -->
                </div>
              </div>

              <div
                v-if="hasDataAi && dataAI.ai.references.length"
                class="search-content-ai-body-right"
              >
                <span class="text-xs text-geb-aquamarine">{{
                  allText.sources
                }}</span>
                <div class="section">
                  <ul class="space-y-2">
                    <li
                      v-for="(item, index) in dataAI.ai.references"
                      :key="index"
                    >
                      <a
                        @click.prevent="onReferenceClick(item.url, item.title)"
                        :title="item.title"
                        class="text-xs font-semibold flex items-center gap-x-2"
                      >
                        <i
                          class="w-6 h-6 text-blue-600 fill-none flex-none"
                          v-icon:search-report
                        ></i>
                        <span class="line-clamp-2">{{ item.title }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div
          v-if="hasErrorAI"
          class="bg-white bg-opacity-20 p-3 md:p-6 rounded-lg"
        >
          <p class="text-sm text-white">{{ errorMessageAI }}</p>
        </div>

        <div class="search-content-ai-disclaimer" v-if="allText.disclaimer">
          <p class="text-xs text-white text-center mt-8">
            {{ allText.disclaimer }}
          </p>
        </div>
      </div>

      <div class="flex flex-col gap-6.5">
        <div
          class="flex flex-col md:flex-row justify-between gap-3"
          v-if="hasItems"
        >
          <p class="text-sm">
            {{ localData.pager.total }} {{ allText.resultCount }}
          </p>
          <div
            v-if="
              localData.design.sorting_options &&
              localData.design.sorting_options.length
            "
            class="sorting-container-ai"
          >
            <h4 class="sorting-container-ai__title">
              {{ "Ordenar por" }}
            </h4>
            <div class="sorting-container-ai__dropdown" ref="dropdown">
              <button
                type="button"
                @click="toggleDropdown"
                class="sorting-container-ai__dropdown-button"
              >
                {{
                  selectedOption
                    ? selectedOption.name
                    : allText.sortingPlaceholder
                }}
                <i
                  class="sorting-container-ai__dropdown-button-icon"
                  :class="{ 'is-open': isDropdownOpen }"
                  v-icon:chevron-down
                ></i>
              </button>

              <div
                v-if="isDropdownOpen"
                class="sorting-container-ai__dropdown-list"
              >
                <ul>
                  <li
                    v-for="(option, index) in localData.design.sorting_options"
                    :key="`sorting-opt-${index}`"
                    @click="handleSelect(option)"
                    class="sorting-container-ai__dropdown-item"
                  >
                    {{ option.name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-col gap-10" v-if="hasItems">
          <div class="search-page__tab-list">
            <button
              type="button"
              @click="onSetFilter(null)"
              :class="{ 'is-active': !currentFilter }"
            >
              {{ allText.filterAll }}
            </button>
            <button
              v-for="(item, index) in filters"
              type="button"
              @click="onSetFilter(item)"
              :key="`filter-${item}-${index}`"
              :class="{
                'is-active': currentFilter == item,
              }"
            >
              {{ item }}
            </button>
          </div>

          <ul class="flex flex-col gap-y-8" data-testid="result-search-list">
            <li
              class="bg-white cursor-pointer text-geb-gray-700 hover:text-geb-green-700"
              v-for="(item, index) in listItems"
              :key="index"
            >
              <a
                @click.prevent="onLinkClick(item.link, item.title, index + 1)"
                class="flex gap-3 flex-nowrap"
              >
                <span
                  class="w-6 h-6 mt-0.5 fill-none flex-shrink-0"
                  v-icon:[getLinkIcon(item)]
                ></span>
                <div>
                  <h3 class="font-semibold text-lg sm:text-xl mb-1.5">
                    {{ item.title }}
                  </h3>
                  <div
                    class="flex justify-between items-start gap-10"
                    v-if="item.resume"
                  >
                    <p
                      class="text-sm leading-relaxed line-clamp-3"
                      v-html="item.resume.trim()"
                    ></p>
                  </div>
                  <div class="flex items-center gap-1" v-if="isPDF(item)">
                    <span class="text-sm leading-relaxed">{{
                      allText.download
                    }}</span>
                    <span
                      class="w-4 h-4 fill-none flex-shrink-0"
                      v-icon:tw-download
                    ></span>
                  </div>
                </div>
              </a>
            </li>
          </ul>
          <div class="search-page__pagination">
            <button
              type="button"
              class="search-page__pagination-button"
              @click="getUpdatedPageLink(1)"
            >
              <i class="w-4 h-4" v-icon:nav-first></i>
            </button>
            <button
              type="button"
              class="search-page__pagination-button"
              @click="getUpdatedPageLink(localData.pager.previous_page)"
            >
              <i class="w-4 h-4" v-icon:nav-prev></i>
            </button>
            <template v-for="item in localData.pager.last_page">
              <button
                :key="`${item}-paginator`"
                v-if="showPage(item)"
                type="button"
                @click="getUpdatedPageLink(item)"
                class="search-page__pagination-button search-page__pagination-button-item"
                :class="{ 'is-active': localData.pager.current_page == item }"
              >
                {{ item }}
              </button>
              <span
                class="search-page__pagination-ellipsis"
                :key="`${item}-paginator-ellipsis`"
                v-if="
                  (localData.pager.current_page > 3 && item == 1) ||
                  (localData.pager.current_page <
                    localData.pager.last_page - 2 &&
                    item == localData.pager.last_page - 1)
                "
                >...</span
              >
            </template>
            <button
              type="button"
              class="search-page__pagination-button"
              @click="getUpdatedPageLink(localData.pager.next_page)"
            >
              <i class="w-4 h-4" v-icon:nav-next></i>
            </button>
            <button
              type="button"
              class="search-page__pagination-button"
              @click="getUpdatedPageLink(localData.pager.last_page)"
            >
              <i class="w-4 h-4" v-icon:nav-last></i>
            </button>
          </div>
        </div>
        <div class="flex justify-center my-4" v-else-if="hasError">
          <p>
            {{ errorMessage }}
          </p>
        </div>

        <div
          class="flex justify-center my-4"
          v-else-if="!hasItems && !hasError && !isSearching"
        >
          <p>
            {{ allText.noResultsMessage }}
          </p>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { marked } from "../../utils/markdown.esm.js";
import throttle from "lodash.throttle";
import Typed from "typed.js";

import {
  dispatchSearchAIClickGAEvent,
  dispatchSearchClickGAEvent,
  dispatchSearchAIResultGAEvent,
  dispatchSearchResultGAEvent,
} from "../../utils/index.js";
import { generateRecaptchaToken } from "../../utils/recaptcha.js";

export default {
  name: "SearchAiPage",
  props: {
    allText: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    apiUrl: {
      type: String,
      default: "",
    },
    apiIaUrl: {
      type: String,
      default: "",
    },
    recaptchaEnabled: {
      type: Boolean,
      default: false,
    },
    recaptchaPublicKey: {
      type: String,
      default: "",
    },
    timeoutAi: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      isSearching: false,
      isSearchingIA: false,
      recaptchaToken: "",
      selectedOption: null,
      localData: JSON.parse(JSON.stringify(this.data)),
      currentFilter: null,
      dataAI: null,
      typed: null,
      showTypedTextShow: false,
      showViewMore: false,
      hasError: false,
      hasErrorAI: false,
      errorMessage: "",
      errorMessageAI: "",
      isDropdownOpen: false,
      throttledCheckClamp: null,
    };
  },
  filters: {
    replaceLabel(value, labelsMap) {
      // return labelsMap[value.toLowerCase()] ?? value;
      return value;
    },
  },
  computed: {
    dataAggregations() {
      const asArray = Object.entries(this.localData.aggregations || {});
      const filtered = asArray.filter(([key, value]) => !!value);
      return Object.fromEntries(filtered);
    },
    filters() {
      const result = [];
      this.localData.items.forEach((item) => {
        if (!result.includes(item.type)) result.push(item.type);
      });
      return result;
    },
    listItems() {
      return this.localData.items?.filter((item) =>
        this.currentFilter ? item.type == this.currentFilter : true
      );
    },
    hasItems() {
      return this.localData?.items?.length > 0;
    },
    hasDataAi() {
      return this.dataAI?.ai;
    },
  },
  mounted() {
    this.throttledCheckClamp = throttle(this.setShowViewMore, 200);
    window.addEventListener("resize", this.throttledCheckClamp);
    document.addEventListener("click", this.closeOnClickOutside);

    this.selectedOption = this.localData?.design?.sorting_options.find(
      (el) => el.value === this.localData?.design?.sorted_by
    );

    if (this.dataAI?.ai?.response) {
      this.typed = new Typed(this.$refs.typedText, {
        strings: [this.parseMarkdown(this.dataAI.ai.response)],
        typeSpeed: 1,
        showCursor: false,
      });
    }
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeOnClickOutside);
    if (this.throttledCheckClamp) {
      window.removeEventListener("resize", this.throttledCheckClamp);
    }
  },
  methods: {
    parseMarkdown(str) {
      return marked.parse(str);
    },
    isPDF(item) {
      return item.type?.toLowerCase() === "archivo geb";
    },
    getLinkIcon(item) {
      return this.isPDF(item) ? "download-file" : "article";
    },
    setShowViewMore() {
      this.$nextTick(() => {
        const paragraph = this.$refs.typedText;
        const clon = paragraph?.cloneNode(true);
        if (clon) {
          clon.style.display = "block";
          clon.style.position = "absolute";
          clon.style.visibility = "hidden";
          clon.style.maxHeight = "none";
          clon.style.webkitLineClamp = "unset";
          clon.style.width = `${paragraph.clientWidth}px`;
          clon.innerText = this.escapeHtml(this.dataAI.ai.response);
          document.body.appendChild(clon);

          const lineHeight = parseFloat(getComputedStyle(clon).lineHeight);
          const maxHeight = lineHeight * 5;

          this.showViewMore = clon.clientHeight > maxHeight;

          document.body.removeChild(clon);
        }
      });
    },
    showPage(item) {
      return (
        item == 1 ||
        item == this.localData.pager.last_page ||
        item == this.localData.pager.current_page ||
        (this.localData.pager.current_page <= 3 && item <= 3) ||
        (this.localData.pager.current_page > 3 &&
          item == this.localData.pager.current_page - 1) ||
        (this.localData.pager.current_page >=
          this.localData.pager.last_page - 2 &&
          item >= this.localData.pager.last_page - 2) ||
        (this.localData.pager.current_page <
          this.localData.pager.last_page - 2 &&
          item == this.localData.pager.current_page + 1)
      );
    },
    onSetFilter(value) {
      this.currentFilter = value;
    },
    async getRecaptchaToken() {
      const recaptchaToken = await generateRecaptchaToken(
        this.recaptchaEnabled,
        this.recaptchaPublicKey
      );
      this.recaptchaToken = recaptchaToken;
      return recaptchaToken;
    },
    async searchGeneral() {
      try {
        this.hasError = false;
        this.isSearching = true;
        this.localData.items = [];
        const recaptchaToken = await this.getRecaptchaToken();
        const form = this.$refs.searchForm;
        const formData = new FormData(form);

        formData.set(
          "filters[keyword]",
          this.localData.applied_filters.keyword
        );
        if (this.selectedOption)
          formData.set("sort", this.selectedOption.value);
        formData.set("recaptcha_token", recaptchaToken);

        const updatedData = [...formData.entries()];
        const formString = updatedData
          .map((x) => `${x[0]}=${encodeURIComponent(x[1])}`)
          .join("&");

        const response = await fetch(`${this.apiUrl}?${formString}`);
        const responseJson = await response.json();

        if (responseJson.status === 500) {
          throw new Error(`Error: ${responseJson.message}`);
        } else {
          this.localData = responseJson;
        }

        dispatchSearchResultGAEvent(
          "general",
          this.localData.applied_filters.keyword,
          this.hasItems
        );
      } catch (error) {
        this.hasError = true;
        if (error.name !== "AbortError") {
          if (navigator.onLine) {
            this.errorMessage = this.allText.errorMessage;
            throw new Error(
              "Hubo un error al realizar la búsqueda, inténtalo nuevamente."
            );
          } else {
            this.errorMessage = this.allText.offlineMessage;
            throw new Error(
              "Error, verifica tu conexión y vuelve a intentarlo."
            );
          }
        }
      } finally {
        this.isSearching = false;
      }
    },
    async searchAi() {
      try {
        this.showViewMore = false;
        this.showTypedTextShow = false;
        this.hasErrorAI = false;
        this.isSearchingIA = true;

        const recaptchaToken = await this.getRecaptchaToken();

        const form = this.$refs.searchForm;
        const formData = new FormData(form);

        formData.set(
          "filters[keyword]",
          this.localData.applied_filters.keyword
        );
        formData.set("recaptcha_token", recaptchaToken);

        const updatedData = [...formData.entries()];
        const formString = updatedData
          .map((x) => `${x[0]}=${encodeURIComponent(x[1])}`)
          .join("&");

        const timeoutSignal = AbortSignal.timeout(this.timeoutAi);

        const response = await fetch(`${this.apiIaUrl}?${formString}`, {
          signal: timeoutSignal,
        });
        const responseJson = await response.json();

        let newTypedText = null;

        if (responseJson.status === 500) {
          this.dataAI = null;
          throw new Error(`Error: ${responseJson.message}`);
        } else {
          if (responseJson.ai.statusCode === 500) {
            this.errorMessageAI = this.allText.errorMessage;
            throw new Error(this.allText.errorMessage);
          }

          this.dataAI = responseJson;

          newTypedText =
            responseJson.ai.statusCode === 204
              ? this.allText.genericIA
              : this.dataAI.ai.response;

          dispatchSearchAIResultGAEvent(
            "general",
            this.localData.applied_filters?.keyword ?? "",
            this.dataAI.ai.statusCode === 200 && !!this.dataAI.ai.response
          );
        }

        if (newTypedText) {
          this.timer = setTimeout(() => {
            this.typed = new Typed(this.$refs.typedText, {
              strings: [this.escapeHtml(newTypedText)],
              typeSpeed: 1,
              showCursor: false,
            });
            this.setShowViewMore();
          }, 500);
        }
      } catch (error) {
        this.hasErrorAI = true;
        if (error.name !== "AbortError") {
          if (navigator.onLine) {
            if (error.name === "TimeoutError") {
              throw new Error(error);
            } else {
              throw new Error(
                "Hubo un error al realizar la búsqueda con IA, inténtalo nuevamente.",
                error
              );
            }
          } else {
            throw new Error(
              "Error, verifica tu conexión y vuelve a intentarlo."
            );
          }
        }
      } finally {
        this.isSearchingIA = false;
      }
    },
    submitSearch() {
      if (this.isSearching || this.isSearchingIA) return;

      this.updateUrlState();
      this.searchAi().catch((error) => console.error(error));
      this.searchGeneral().catch((error) => console.error(error));
    },
    onReferenceClick(link, title) {
      dispatchSearchAIClickGAEvent(
        "general",
        this.localData.applied_filters.keyword ?? "",
        title,
        link
      );
      window.location.href = link;
    },
    async updateUrlState() {
      const recaptchaToken = await this.getRecaptchaToken();
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set(
        "filters[keyword]",
        this.localData.applied_filters.keyword
      );
      searchParams.set("recaptcha_token", recaptchaToken);
      searchParams.set("page", 1);

      window.history.pushState(
        {},
        "",
        `${window.location.pathname}?${searchParams.toString()}`
      );
    },
    async onLinkClick(link, title, index) {
      dispatchSearchClickGAEvent(
        "general",
        this.localData.applied_filters.keyword ?? "",
        index + (this.localData.pager.current_page - 1) * 10,
        title
      );
      window.location.href = link;
    },
    async getUpdatedPageLink(page) {
      const recaptchaToken = await this.getRecaptchaToken();

      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set(
        "filters[keyword]",
        this.localData.applied_filters.keyword
      );
      searchParams.set("page", page);
      searchParams.set("recaptcha_token", recaptchaToken);

      window.location.href = `${
        window.location.pathname
      }?${searchParams.toString()}`;
    },
    getStringTruncated(value) {
      const shortText = value.split(/\s+/).slice(0, 4).join(" ");
      return value.length > shortText.length ? `${shortText}...` : shortText;
    },
    escapeHtml(text) {
      const map = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;",
      };
      return text.replace(/[&<>"']/g, (m) => map[m]);
    },
    toggleTypedTextShow() {
      this.showTypedTextShow = !this.showTypedTextShow;
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    async handleSelect(option) {
      this.selectedOption = option;
      this.isDropdownOpen = false;
      this.searchGeneral();
    },
    closeOnClickOutside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    },
  },
};
</script>

<style>
@keyframes magicWand {
  0% {
    transform: rotate(0deg) scale(1);
  }

  20% {
    transform: rotate(-15deg) scale(1.1);
  }

  40% {
    transform: rotate(15deg) scale(1.1);
  }

  60% {
    transform: rotate(-10deg) scale(1.05);
  }

  80% {
    transform: rotate(10deg) scale(1.05);
  }

  100% {
    transform: rotate(0deg) scale(1);
  }
}

.animate-magic-wand {
  animation: magicWand 1s ease-in-out infinite;
}
</style>
